import io from 'socket.io-client';
import { SOCKET_HOST } from '../constants/environment';
import { v4 as uuid } from 'uuid';

export const SOCKET_HOST_URL = SOCKET_HOST || '';
export const socketInstance = io(SOCKET_HOST_URL, {
    secure: true,
});

export const newSessionId: string = uuid();

export const getSocket = () => socketInstance;
